var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigation-layout", { ref: "navigationlayout" }, [
    _c("main", [
      _c(
        "form",
        {
          staticClass: "md-layout md-alignment-top-center",
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.validateLogin($event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "md-layout-item md-max-size md-medium-size-33 md-small-size-50 md-xsmall-size-100"
            },
            [
              _c("div", { staticClass: "md-title" }, [_vm._v("Login")]),
              _vm._v(" "),
              _c("field", {
                ref: "email",
                attrs: {
                  fieldName: "email",
                  fieldType: "email",
                  validations: { required: true, email: true },
                  fieldValue: _vm.form.email,
                  fieldLabel: "Email",
                  fieldId: "email",
                  sending: _vm.sending
                },
                on: {
                  setfield: function($event) {
                    return _vm.setFormField($event)
                  }
                }
              }),
              _vm._v(" "),
              _c("field", {
                ref: "password",
                attrs: {
                  fieldName: "password",
                  fieldType: "password",
                  validations: { required: true, min: 6 },
                  fieldValue: _vm.form.password,
                  fieldLabel: "Password",
                  fieldId: "password",
                  sending: _vm.sending
                },
                on: {
                  setfield: function($event) {
                    return _vm.setFormField($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm.sending
                ? _c("md-progress-bar", {
                    attrs: { "md-mode": "indeterminate" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "md-checkbox",
                {
                  model: {
                    value: _vm.rememberme,
                    callback: function($$v) {
                      _vm.rememberme = $$v
                    },
                    expression: "rememberme"
                  }
                },
                [_vm._v("Remember me")]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-raised md-primary",
                  attrs: { type: "submit", disabled: _vm.sending }
                },
                [_vm._v("Login")]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa4b3aba", { render: render, staticRenderFns: staticRenderFns })
  }
}